module.exports = __webpack_public_path__ + "static/media/nero_trasparente.0189408a.png";